var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wl-image" },
    [
      typeof _vm.src === "string"
        ? [
            _c(
              "el-image",
              _vm._b(
                {
                  ref: "wl-image",
                  attrs: { src: _vm.src },
                  on: { load: _vm.load },
                },
                "el-image",
                _vm.$attrs,
                false
              )
            ),
          ]
        : Array.isArray(_vm.src)
        ? [
            _vm._l(_vm.src, function (s, k) {
              return [
                k === _vm.srcIndex || k === _vm.LoadingIndex
                  ? _c(
                      "el-image",
                      _vm._b(
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: k === _vm.srcIndex,
                              expression: "k === srcIndex",
                            },
                          ],
                          ref: "wl-image",
                          refInFor: true,
                          attrs: { src: _vm.src[k] },
                          on: { load: _vm.load },
                        },
                        "el-image",
                        _vm.$attrs,
                        false
                      )
                    )
                  : _vm._e(),
              ]
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }